import type {
  HeatpumpsFunnelSettingsInterface,
  HeatpumpsFunnelStep,
} from '@innogy/feh/models';
import { createNamedFunnelActions } from '@innogy/feh/shared';
import type { GenericProductData } from '@legacy/common-ui-models';
import { createAction } from '@ngrx/store';

const funnelType = 'Heatpumps';
const PREFIX = `[${funnelType} Funnel]`;

export const {
  initializeHeatpumpsFunnelStepAction,
  clearHeatpumpsFunnelInitializedAction,
  setHeatpumpsFunnelInitializedAction,
  onHeatpumpsFunnelNavigationAction,
  handleHeatpumpsFunnelGenericErrorAction,
  handleHeatpumpsFunnelPrivateErrorAction,
  selectHeatpumpsProductAction,
  resetHeatpumpsProductSelectionAction,
  mintHeatpumpsTrackingIdAction,
} = createNamedFunnelActions<
  typeof funnelType,
  HeatpumpsFunnelStep,
  HeatpumpsFunnelSettingsInterface,
  GenericProductData
>(funnelType);

export const handleHeatpumpsFunnelAddressNotFoundErrorAction = createAction(
  `${PREFIX} Address not found Error`
);
